import { render } from "./art-direction.vue?vue&type=template&id=45471e52"
import script from "./art-direction.vue?vue&type=script&lang=js"
export * from "./art-direction.vue?vue&type=script&lang=js"

import exportComponent from "/home/djordje/code/uwp/lyle-and-scott/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__